<template>
  <div>
    <page-header :breadcrumRoutes="routes" title="Formulario alta individual" />

    <a-form
      name="form"
      layout="vertical"
      ref="formRef"
      :model="formState"
      :rules="formRules"
    >
      <a-row type="flex" class="mb-2" :gutter="[20, 8]">
        <a-col flex="auto">
          <a-card>
            <a-row type="flex">
              <a-col :span="24">
                <a-form-item
                  label="Envío de información a"
                  required
                  name="typeForm"
                >
                  <a-radio-group
                    name="radioGroup"
                    v-model:value="formState.typeForm"
                  >
                    <a-radio value="1">Colaborador</a-radio>
                    <a-radio value="2">Compañía</a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-col>
            </a-row>
          </a-card>
        </a-col>
        <a-col flex="auto">
          <a-card>
            <a-row type="flex">
              <a-col :span="24">
                <a-form-item
                  label="Inicio de vigencia"
                  required
                  name="validityDate"
                >
                  <a-date-picker
                    placeholder="DD-MM-AAAA"
                    v-model:value="formState.validityDate"
                    :format="DATE_FORMAT"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </a-card>
        </a-col>
      </a-row>

      <a-card class="mt-2">
        <a-row>
          <a-col>
            <a-typography-title class="text-gray-8" :level="4">
              Datos colaborador
            </a-typography-title>
          </a-col>
        </a-row>
        <a-row :gutter="16" type="flex">
          <a-col :xs="24" :md="8">
            <a-form-item ref="rut" label="RUT" name="rut" has-feedback>
              <input-rut v-model="formState.rut" />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :md="8">
            <a-form-item
              ref="firstName"
              label="Primer nombre"
              name="firstName"
              has-feedback
            >
              <input-text
                placeholder="Primer nombre"
                v-model="formState.firstName"
                :disabled="collaboratorSelectsDisabled"
                :loading="collaboratorSelectsDisabled"
              />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :md="8">
            <a-form-item
              ref="secondName"
              label="Segundo nombre"
              name="secondName"
              has-feedback
            >
              <input-text
                placeholder="Segundo nombre"
                v-model="formState.secondName"
                :disabled="collaboratorSelectsDisabled"
                :loading="collaboratorSelectsDisabled"
              />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :md="8">
            <a-form-item
              ref="firstSurname"
              label="Primer apellido"
              name="firstSurname"
              has-feedback
            >
              <input-text
                placeholder="Primer apellido"
                v-model="formState.firstSurname"
                :disabled="collaboratorSelectsDisabled"
                :loading="collaboratorSelectsDisabled"
              />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :md="8">
            <a-form-item
              ref="secondSurname"
              label="Segundo apellido"
              name="secondSurname"
              has-feedback
            >
              <input-text
                placeholder="Segundo apellido"
                v-model="formState.secondSurname"
                :disabled="collaboratorSelectsDisabled"
                :loading="collaboratorSelectsDisabled"
              />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :md="8">
            <a-form-item ref="email" label="Correo" name="email" has-feedback>
              <input-email
                v-model="formState.email"
                :disabled="collaboratorSelectsDisabled"
                :loading="collaboratorSelectsDisabled"
              />
            </a-form-item>
          </a-col>
          <a-col
            v-if="selectedFormFields.some((f) => f.field === 'gender')"
            :xs="24"
            :md="8"
          >
            <a-form-item
              ref="gender"
              label="Sexo designado al nacer"
              name="gender"
              has-feedback
              :rules="{
                required: !!selectedFormFields.find((f) => f.field === 'gender')
                  ?.required,
                message: 'Seleccione sexo designado al nacer',
                trigger: 'change',
                type: 'string'
              }"
            >
              <select-ordered
                v-model="formState.gender"
                :options="genderOptions"
                placeholder="Seleccione una opción"
                :disabled="collaboratorSelectsDisabled"
                :loading="collaboratorSelectsDisabled"
              />
            </a-form-item>
          </a-col>
          <a-col
            v-if="selectedFormFields.some((f) => f.field === 'birthdayDate')"
            :xs="24"
            :md="8"
          >
            <a-form-item
              ref="birthdayDate"
              label="Fecha de nacimiento"
              name="birthdayDate"
              has-feedback
              :rules="{
                required: !!selectedFormFields.find(
                  (f) => f.field === 'birthdayDate'
                )?.required,
                message: 'Ingrese fecha de nacimiento',
                trigger: 'change',
                type: 'object'
              }"
            >
              <a-date-picker
                :style="{ width: '100%' }"
                format="DD-MM-YYYY"
                placeholder="Fecha de nacimiento"
                v-model:value="formState.birthdayDate"
                :disabled-date="isFutureDate"
                :disabled="collaboratorSelectsDisabled"
                :loading="collaboratorSelectsDisabled"
              />
              <a-alert
                v-if="isUnderPolicyHolderMinAge(formState.birthdayDate)"
                type="warning"
                show-icon
                :message="POLICY_HOLDER_UNDERAGE_WARNING"
                class="mt-2"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-card>

      <a-card class="mt-2">
        <a-row>
          <a-col>
            <a-typography-title class="text-gray-8" :level="4">
              Datos corporativos
            </a-typography-title>
          </a-col>
        </a-row>
        <a-row :gutter="16" type="flex">
          <a-col :xs="24" :md="8">
            <a-form-item
              ref="company"
              label="Empresa"
              name="company"
              has-feedback
            >
              <select-ordered
                placeholder="Selecciona una empresa"
                :disabled="inputsLockState[0].disabled"
                v-model="formState.company"
                :options="companies"
              />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :md="8">
            <a-form-item
              ref="insurance"
              label="Aseguradora"
              name="insurance"
              has-feedback
            >
              <select-ordered
                placeholder="Selecciona una aseguradora"
                :disabled="inputsLockState[1].disabled"
                :loading="inputsLockState[1].loading"
                v-model="formState.insurance"
                :options="insuranceCompanies"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-card>

      <a-card class="mt-2">
        <a-typography-title class="text-gray-8" :level="4">
          Pólizas y coberturas
        </a-typography-title>
        <div style="display: flex; flex-direction: column; gap: 16px">
          <a-row
            :gutter="16"
            v-if="
              validRut &&
              formState.rut !== '' &&
              employeeId !== '' &&
              formState.company !== '' &&
              formState.insurance !== ''
            "
          >
            <a-col :span="8">
              <a-button @click="openPolicyCoverage" id="coverages_and_policies">
                Coberturas vigentes
                <a-tag color="geekblue" class="ml-2 mr-0">
                  {{ currentCoverages.length }}
                </a-tag>
              </a-button>
              <policy-coverages
                ref="policyCoveragesModalRef"
                v-model="policyStatus"
                :loading="loadingPolicyCoverages"
                :currentCoverages="currentCoverages"
                :notCurrentCoverages="notCurrentCoverages"
              />
            </a-col>
          </a-row>
          <a-row :gutter="16" align="middle">
            <a-col :xs="24" :md="8">
              <a-form-item
                ref="currentPolicy"
                label="Pólizas"
                name="currentPolicy"
                has-feedback
              >
                <select-ordered
                  :disabled="inputsLockState[2].disabled"
                  :loading="inputsLockState[2].loading"
                  v-model="formState.currentPolicy"
                  :options="inputsLockState[2].loading ? [] : companyPolicies"
                  mode="multiple"
                  @change="handleAddPolicy"
                  allowClear
                />
                <a-alert
                  v-if="insuranceBrokerWarning"
                  type="error"
                  show-icon
                  :message="insuranceBrokerWarning"
                  class="mt-2"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row
            v-for="(policy, index) in formState.policies"
            :key="index"
            align="middle"
            :gutter="16"
          >
            <a-col :span="8">
              <a-form-item
                :name="['policies', index, 'groupCompanies']"
                :label="`Grupos de póliza ${policy.numberPolicy}`"
                style="display: flex"
                :rules="{
                  required: true,
                  message: 'Seleccione al menos un grupo de póliza',
                  validator: checkGroups,
                  trigger: 'change'
                }"
              >
                <select-ordered
                  :disabled="inputsLockState[3].disabled"
                  :loading="inputsLockState[3].loading"
                  v-model="policy.groupCompanies"
                  :options="policy.groupOptions"
                  mode="multiple"
                  allowClear
                />
              </a-form-item>
            </a-col>
            <a-col>
              <a-button danger @click="handleDeletePolicy(policy.policyId)">
                <template #icon><DeleteOutlined /></template>
              </a-button>
            </a-col>
          </a-row>
          <a-row v-if="formState.typeForm == 2" :gutter="16">
            <a-col :span="24">
              <a-form-item
                name="coverageIds"
                label="Coberturas del titular"
                :rules="{
                  required: true,
                  message: 'Seleccione al menos una cobertura.'
                }"
              >
                <a-checkbox-group v-model:value="formState.coverageIds">
                  <a-checkbox
                    v-for="coverage in availableHolderCoverages"
                    :key="coverage.value"
                    :value="coverage.value"
                    :disabled="coverage.required"
                  >
                    {{ coverage.label }}
                  </a-checkbox>
                </a-checkbox-group>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-if="isIncomeRequired" :gutter="16">
            <a-col :span="8">
              <a-form-item
                name="incomeAmount"
                label="Renta"
                :rules="{
                  required: true,
                  message: 'Ingrese renta',
                  trigger: 'change'
                }"
              >
                <a-input
                  v-model:value="formState.incomeAmount"
                  @keyup="formatIncome"
                  maxLength="40"
                  placeholder="Ingrese renta"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="8">
              <template
                v-if="
                  formState.typeForm == 1 &&
                  formState.policies.length > 0 &&
                  insuranceFormType !== 'DIGITAL_FORM'
                "
              >
                <a-form-item
                  name="documents"
                  :label="`Seleccionar formularios de ${
                    insuranceCompanies.find(
                      (x) => x.value == formState.insurance
                    )?.label || ''
                  }`"
                >
                  <a-checkbox-group v-model:value="formState.documents">
                    <div v-for="d in insuranceDocuments" :key="d.value">
                      <a-checkbox :value="d.value">
                        {{ d.label }}
                      </a-checkbox>
                    </div>
                  </a-checkbox-group>
                </a-form-item>
              </template>
              <template
                v-if="
                  formState.typeForm == 2 &&
                  formState.insurance !== null &&
                  formState.insurance !== ''
                "
              >
                <a-row :gutter="[24, 8]" type="flex">
                  <a-col>
                    <a-form-item
                      name="fileList"
                      :label="`Adjuntar archivos para incorporación a ${
                        insuranceCompanies.find(
                          (x) => x.value == formState.insurance
                        )?.label || ''
                      }`"
                    >
                      <a-upload
                        :file-list="formState.fileList"
                        :multiple="true"
                        :remove="handleRemove"
                        :before-upload="beforeUpload"
                      >
                        <a-button>
                          <upload-outlined></upload-outlined>
                          Subir archivo
                        </a-button>
                      </a-upload>
                    </a-form-item>
                  </a-col>
                </a-row>
              </template>
            </a-col>
          </a-row>
        </div>
      </a-card>

      <Transition>
        <a-card class="mt-2" v-if="formState.typeForm == 1">
          <a-row :gutter="32">
            <a-col :xs="24" :md="12">
              <a-typography-title class="text-gray-8" :level="4">
                Mensaje a colaborador
              </a-typography-title>
              <a-form-item
                ref="message"
                label="Escribe un mensaje para el colaborador"
                name="message"
                has-feedback
              >
                <a-textarea
                  v-model:value="formState.message"
                  placeholder="Escribe aquí..."
                  :rows="8"
                  :maxlength="3000"
                />
              </a-form-item>
            </a-col>
            <a-col :xs="24" :md="12">
              <a-row :gutter="[24, 8]" type="flex">
                <a-col :xs="24" :md="12">
                  <a-form-item name="optionalFiles" label="Archivos opcionales">
                    <a-upload
                      :file-list="formState.optionalFiles"
                      :multiple="true"
                      :remove="handleRemoveOptional"
                      :before-upload="beforeUploadOptional"
                      accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                    >
                      <a-button>
                        <upload-outlined></upload-outlined>
                        Subir archivo
                      </a-button>
                    </a-upload>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
        </a-card>
      </Transition>

      <a-card v-if="formState.typeForm == 2" class="mt-2">
        <a-typography-title class="text-gray-8" :level="4">
          Cargas
        </a-typography-title>
        <div>
          <a-empty
            v-if="formState.dependents.length === 0"
            description="No has agregado cargas"
          />
          <template
            v-for="(dependent, dependentIndex) in formState.dependents"
            :key="dependentIndex"
          >
            <a-row type="flex" justify="space-between" align="middle">
              <a-col>
                <a-typography-title :level="5" style="margin: 0">
                  Carga {{ dependentIndex + 1 }}
                </a-typography-title>
              </a-col>
              <a-col>
                <a-button
                  danger
                  size="small"
                  @click="() => handleDeleteDependent(dependentIndex)"
                >
                  Eliminar
                </a-button>
              </a-col>
            </a-row>
            <a-row type="flex" :gutter="16" style="margin-top: 16px">
              <a-col :span="12">
                <a-form-item
                  :name="['dependents', dependentIndex, 'rut']"
                  label="Rut"
                  :rules="[
                    { validator: rutValidator },
                    { required: true, message: 'El rut es obligatorio.' }
                  ]"
                >
                  <input-rut v-model="dependent.rut" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item
                  :name="['dependents', dependentIndex, 'dateOfBirth']"
                  label="Fecha de nacimiento"
                  :rules="{
                    required: true,
                    message: 'La fecha de nacimiento es obligatoria.',
                    trigger: 'change',
                    type: 'object'
                  }"
                >
                  <a-date-picker
                    :style="{ width: '100%' }"
                    format="DD-MM-YYYY"
                    placeholder="Fecha de nacimiento"
                    v-model:value="dependent.dateOfBirth"
                  />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row type="flex" :gutter="16">
              <a-col :span="12">
                <a-form-item
                  :name="['dependents', dependentIndex, 'firstName']"
                  label="Primer nombre"
                  :rules="{
                    required: true,
                    message: 'El primer nombre es obligatorio.'
                  }"
                >
                  <input-text v-model="dependent.firstName" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item
                  :name="['dependents', dependentIndex, 'secondName']"
                  label="Segundo nombre"
                >
                  <input-text v-model="dependent.secondName" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row type="flex" :gutter="16">
              <a-col :span="12">
                <a-form-item
                  :name="['dependents', dependentIndex, 'firstSurname']"
                  label="Apellido paterno"
                  :rules="{
                    required: true,
                    message: 'El primer apellido es obligatorio.'
                  }"
                >
                  <input-text v-model="dependent.firstSurname" />
                </a-form-item>
              </a-col>
              <a-col :span="12">
                <a-form-item
                  :name="['dependents', dependentIndex, 'secondSurname']"
                  label="Apellido materno"
                >
                  <input-text v-model="dependent.secondSurname" />
                </a-form-item>
              </a-col>
            </a-row>
            <a-row type="flex" :gutter="16">
              <a-col :span="12">
                <a-form-item
                  :name="['dependents', dependentIndex, 'relationship']"
                  label="Relación"
                  :rules="{
                    required: true,
                    message: 'El tipo de relación es obligatorio.'
                  }"
                >
                  <select-ordered
                    v-model="dependent.relationship"
                    :options="relationOptions"
                    placeholder="Ingrese relación"
                  />
                </a-form-item>
              </a-col>
              <a-col
                v-if="
                  selectedCargasFormFields.some((f) => f.field === 'gender')
                "
                :span="12"
              >
                <a-form-item
                  :name="['dependents', dependentIndex, 'gender']"
                  label="Sexo designado al nacer"
                  :rules="{
                    required: !!selectedCargasFormFields.find(
                      (f) => f.field === 'gender'
                    )?.required,
                    message: 'El sexo designado al nacer es obligatorio.'
                  }"
                >
                  <select-ordered
                    v-model="dependent.gender"
                    :options="genderOptions"
                    placeholder="Seleccione una opción"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </div>
        <a-row type="flex" justify="start">
          <a-button @click="handleAddDependent">Agregar carga</a-button>
        </a-row>
      </a-card>

      <a-card class="mt-2" v-if="formState.typeForm == 2">
        <a-row :gutter="32">
          <a-col :span="12">
            <a-typography-title class="text-gray-8" :level="4">
              Mensaje a compañía aseguradora
            </a-typography-title>
            <a-form-item
              ref="message"
              label="Escribe un mensaje para la compañía aseguradora"
              name="message"
              has-feedback
            >
              <a-textarea
                v-model:value="formState.message"
                placeholder="Escribe aquí..."
                :rows="8"
                :maxlength="3000"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-row :gutter="[24, 8]" type="flex">
              <a-form-item name="optionalFiles" label="Archivos opcionales">
                <a-upload
                  :file-list="formState.optionalFiles"
                  :multiple="true"
                  :remove="handleRemoveOptional"
                  :before-upload="beforeUploadOptional"
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                >
                  <a-button>
                    <upload-outlined></upload-outlined>
                    Subir archivo
                  </a-button>
                </a-upload>
              </a-form-item>
            </a-row>
          </a-col>
        </a-row>
      </a-card>

      <a-form-item class="mt-2">
        <a-row type="flex" class="justify-content-end">
          <a-col>
            <a-button
              size="large"
              class="px-4"
              type="primary"
              @click="onSubmitForm"
              :disabled="!!insuranceBrokerWarning"
              block
            >
              Siguiente
            </a-button>
          </a-col>
        </a-row>
      </a-form-item>
    </a-form>

    <!-- Modal mostrando información de lo que escribió el usuario -->
    <a-modal
      v-model:visible="resumeModal.visibility"
      title="Resumen de alta individual"
      @cancel="closeResumeModal"
      :closable="!resumeModal.buttonLoading"
      :maskClosable="false"
      centered
    >
      <template #footer>
        <a-row type="flex" justify="end">
          <a-col>
            <a-space>
              <a-button
                @click="closeResumeModal"
                :disabled="resumeModal.buttonLoading"
              >
                Cancelar
              </a-button>
              <a-button
                key="submit"
                type="primary"
                @click="createIncorporation"
                :loading="resumeModal.buttonLoading"
              >
                Enviar
              </a-button>
            </a-space>
          </a-col>
        </a-row>
      </template>

      <a-typography-title class="text-gray-8 fw-regular mb-4" :level="5">
        Revisa que los datos ingresados estén correctos.
      </a-typography-title>
      <a-descriptions class="mb-4" bordered>
        <a-descriptions-item label="Inicio de vigencia" :span="3">
          {{ resumeModal.data.date }}
        </a-descriptions-item>
      </a-descriptions>
      <a-descriptions class="mb-4" title="Datos corporativos" bordered>
        <a-descriptions-item label="Aseguradora" :span="3">
          {{ resumeModal.data.insurer }}
        </a-descriptions-item>
        <a-descriptions-item label="Empresa" :span="3">
          {{ resumeModal.data.company }}
        </a-descriptions-item>
        <a-descriptions-item label="Pólizas" :span="3">
          {{ resumeModal.data.policies }}
        </a-descriptions-item>
        <a-descriptions-item
          label="Formularios"
          :span="3"
          v-if="
            formState.typeForm == 1 && resumeModal.data.documents.length > 0
          "
        >
          <a-typography-text
            v-for="(d, index_d) in resumeModal.data.documents"
            :key="index_d"
          >
            <p>{{ d }}</p>
          </a-typography-text>
        </a-descriptions-item>
        <a-descriptions-item
          label="Formularios"
          :span="3"
          v-else-if="resumeModal.data.files.length > 0"
        >
          <a-typography-text
            v-for="(f, index_f) in resumeModal.data.files"
            :key="index_f"
          >
            <p>{{ f }}</p>
          </a-typography-text>
        </a-descriptions-item>
      </a-descriptions>
      <a-descriptions title="Datos colaborador" class="mb-4" bordered>
        <a-descriptions-item label="Nombre" :span="3">
          {{
            resumeModal.data.fullName ||
            `${resumeModal.data.name} ${resumeModal.data.last}`
          }}
        </a-descriptions-item>
        <a-descriptions-item label="RUT" :span="3">
          {{ resumeModal.data.rut }}
        </a-descriptions-item>
        <a-descriptions-item label="Correo" :span="3">
          {{ resumeModal.data.email }}
        </a-descriptions-item>
        <a-descriptions-item
          v-if="selectedFormFields.some((f) => f.field === 'birthdayDate')"
          label="Fecha de nacimiento"
          :span="3"
        >
          {{ resumeModal.data.birthdayDate || 'No informado' }}
        </a-descriptions-item>
        <a-descriptions-item
          v-if="selectedFormFields.some((f) => f.field === 'gender')"
          label="Sexo designado al nacer"
          :span="3"
        >
          {{ resumeModal.data.gender || 'No informado' }}
        </a-descriptions-item>
        <a-descriptions-item
          v-if="isIncomeRequired && formState.incomeAmount"
          label="Renta"
          :span="3"
        >
          {{ formState.incomeAmount }}
        </a-descriptions-item>
      </a-descriptions>
      <a-descriptions
        :title="`Carga ${dependentIndex + 1}`"
        class="mb-4"
        v-for="(dependent, dependentIndex) in resumeModal.data.dependents"
        :key="dependent.rut"
        bordered
      >
        <a-descriptions-item label="RUT" :span="3">
          {{ dependent.rut }}
        </a-descriptions-item>
        <a-descriptions-item label="Nombre" :span="3">
          {{ dependent.firstName }} {{ dependent.firstSurname }}
        </a-descriptions-item>
      </a-descriptions>
    </a-modal>

    <!-- Modal sucess -->
    <template v-if="showSuccess">
      <a-modal
        :wrapClassName="'modal-xs'"
        v-model:visible="showSuccess"
        centered
        footer=""
        :maskClosable="false"
      >
        <a-result
          centered
          status="success"
          title="Ticket creado"
          sub-title="Tu ticket de alta individual ha sido creado con éxito."
        >
          <template #extra>
            <router-link
              class="justify-content-center d-flex"
              :to="{ name: 'AltasDetalle', params: { id: ticketId } }"
            >
              <a-button key="console" type="primary">Ver ticket</a-button>
            </router-link>
          </template>
        </a-result>
      </a-modal>
    </template>
    <template v-if="showError">
      <a-modal
        v-model:visible="showError"
        centered
        footer=""
        :maskClosable="false"
      >
        <a-result
          centered
          status="error"
          title="Error"
          sub-title="No se ha podido generar el ticket. Asegúrate de que exista un ticket de alta generado previamente."
        >
          <template #extra>
            <a-button type="primary" @click="() => handleOk()">Cerrar</a-button>
          </template>
        </a-result>
      </a-modal>
    </template>
    <pending-policy-modal
      :visible="showPendingPolicyModal"
      :conflicts="pendingPolicyConflicts"
      ticket-type-label="alta individual"
      :employee-rut="formState.rut"
      ticket-route-name="AltasDetalle"
      @update:visible="showPendingPolicyModal = $event"
    />
  </div>
</template>

<script>
import { computed, onMounted, reactive, ref, watch } from 'vue';
import { message } from 'ant-design-vue';
import { UploadOutlined } from '@ant-design/icons-vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import moment from 'moment';
import { normalizePicker } from '@/utils/calendarDay';
import emailValidator from '@/utils/emailValidator';
import { DeleteOutlined } from '@ant-design/icons-vue';
import PendingPolicyModal from '@/components/tickets/PendingPolicyModal.vue';
import {
  FETCH_COMPANIES,
  FETCH_INSURANCE_COMPANIES,
  FETCH_INSURANCE_COMPANY_POLICY,
  FETCH_INSURANCE_COMPANIES_DOCUMENTS,
  FETCH_EMPLOYEE_DATA_BY_RUT,
  FETCH_CURRENT_EMPLOYEE_COVERAGE,
  GET_COMPANIES,
  GET_INSURANCE_COMPANIES,
  GET_INSURANCE_COMPANY_POLICY,
  GET_LOGGED_USER,
  GET_INSURANCE_COMPANIES_DOCUMENTS,
  GET_EMPLOYEE_DATA,
  POST_INDIVIDUAL_INCORPORATION_TICKET_TO_COMPANY,
  POST_INDIVIDUAL_INCORPORATION_TICKET_TO_COLLABORATOR,
  ACTION_CURRENT_EMPLOYEE_COVERAGE,
  SET_INSURANCE_COMPANY_POLICY
} from '@/store/types';
import { FETCH_TABLE_TICKETS_TEST } from '@/store/ticket/datatable/types';
import parseDate from '@/utils/dateFormatter';
import PageHeader from '@/components/page-header.vue';
import InputText from '@/bewell-components/form-controls/input-text.vue';
import InputRut from '@/bewell-components/form-controls/input-rut.vue';
import InputEmail from '@/bewell-components/form-controls/input-email.vue';
import SelectOrdered from '@/bewell-components/form-controls/select-ordered.vue';
import rutHelper from '@/utils/Ruts';
import { genderOptions, employeeGenderToCode } from '@/utils/gender';
import {
  formatIncomeAmount,
  parseIncomeAmount,
  selectedGroupsRequireIncome
} from '@/utils/incomeAmount';
import notification from '@/utils/notifications';
import Rut from '@/utils/Ruts';
import {
  isFutureDate,
  isUnderPolicyHolderMinAge,
  POLICY_HOLDER_UNDERAGE_WARNING
} from '@/utils/policyHolderBirthday';
import { getInsuranceBrokerWarning } from '@/utils/insuranceBroker';
import EmployeePolicyAndCoverages from '@/components/incorporations/employee-policy-and-coverages.vue';

const routes = [
  {
    path: '/altas',
    breadcrumbName: 'Altas'
  },
  {
    breadcrumbName: 'Individual'
  }
];

export default {
  name: 'AltaIndividual',
  components: {
    'upload-outlined': UploadOutlined,
    'page-header': PageHeader,
    'policy-coverages': EmployeePolicyAndCoverages,
    DeleteOutlined,
    'input-text': InputText,
    'input-rut': InputRut,
    'input-email': InputEmail,
    'select-ordered': SelectOrdered,
    PendingPolicyModal
  },
  setup() {
    const DATE_FORMAT = 'DD-MM-YYYY';

    const router = useRouter();

    const policyStatus = ref('vigente');
    const formRef = ref();
    const ticketId = ref('');
    const formState = reactive({
      typeForm: '1',
      validityDate: '',
      firstName: '',
      secondName: '',
      firstSurname: '',
      secondSurname: '',
      rut: '',
      email: '',
      gender: null,
      birthdayDate: null,
      company: '',
      insurance: '',
      message: '',
      currentPolicy: [],
      policies: [],
      documents: [],
      fileList: [],
      optionalFiles: [],
      coverageIds: [],
      dependents: [],
      incomeAmount: ''
    });
    const showSuccess = ref(false);

    // Company registrations skip the digital form, where the income is usually
    // captured, so it is asked here when a selected group requires it.
    const isIncomeRequired = computed(
      () =>
        formState.typeForm == 2 &&
        selectedGroupsRequireIncome(formState.policies)
    );

    const formatIncome = () => {
      formState.incomeAmount = formatIncomeAmount(formState.incomeAmount);
    };

    // const formatRuts = () => {
    //   formState.rut = rutHelper.formatRut(formState.rut);
    // };

    const handleAddDependent = () => {
      formState.dependents.push({
        rut: '',
        firstName: '',
        secondName: '',
        firstSurname: '',
        secondSurname: '',
        relationship: '',
        gender: null,
        dateOfBirth: null
      });
    };

    const handleDeleteDependent = (dependentIndex) => {
      formState.dependents = formState.dependents.filter(
        (_, idx) => idx !== dependentIndex
      );
    };

    const handleAddPolicy = () => {
      formState.currentPolicy.forEach((policyId) => {
        const policy = companyPolicies.value.find((p) => p.value == policyId);
        const foundPolicy = formState.policies.find(
          (p) => p.policyId == policyId
        );
        if (!foundPolicy) {
          const newPolicy = {
            numberPolicy: policy.label,
            policyId,
            groupCompanies: [],
            groupOptions: policy.groupOptions,
            coverageOptions: policy.coverageOptions
          };
          formState.policies = [...formState.policies, newPolicy];
        }
      });
      formState.policies = formState.policies.filter((p) =>
        formState.currentPolicy.includes(p.policyId)
      );
    };

    const handleDeletePolicy = (policyId) => {
      formState.policies = formState.policies.filter(
        (p) => p.policyId !== policyId
      );
      formState.currentPolicy = formState.currentPolicy.filter(
        (p) => p !== policyId
      );
    };

    const rutValidator = (_, value) => {
      const isValid = rutHelper.validateRut(value);
      if (value && !isValid) return Promise.reject('RUT inválido.');

      const employeeFormattedRut = rutHelper.formatRut(formState.rut);

      if (employeeFormattedRut === rutHelper.formatRut(value))
        return Promise.reject('Debe ser un RUT distinto al RUT del titular.');

      if (formState.dependents.filter((d) => d.rut === value).length > 1)
        return Promise.reject('RUT repetido.');

      return Promise.resolve();
    };

    const employeeId = ref('');

    const inputsLockState = reactive([
      {
        id: 1,
        disabled: false,
        loading: false,
        name: 'company'
      },
      {
        id: 2,
        disabled: true,
        loading: false,
        name: 'insurance'
      },
      {
        id: 3,
        disabled: true,
        loading: false,
        name: 'policy'
      },
      {
        id: 4,
        disabled: true,
        loading: false,
        name: 'group'
      }
    ]);

    const inputStatesHeriarchy = (id) => {
      const i = inputsLockState.findIndex((obj) => obj.id === id);
      for (let index = 0; index < inputsLockState.length; index += 1) {
        if (index <= i + 1) {
          inputsLockState[index].disabled = false;
        } else {
          inputsLockState[index].disabled = true;
        }
      }
    };

    // RUT format validator
    const checkRut = async (_, value) => {
      if (!value) {
        const errorMessage = 'Ingrese RUT';
        return Promise.reject(errorMessage);
      }
      if (rutHelper.validateRut(value)) {
        return Promise.resolve();
      }
      return Promise.reject('RUT no válido');
    };

    // Email format validator
    const checkEmail = async (_, value) => {
      if (!value) {
        return Promise.reject('Ingrese correo electrónico');
      }
      if (emailValidator(value)) {
        return Promise.resolve();
      }
      return Promise.reject('Correo inválido');
    };

    const checkPolicies = async () => {
      if (formState.policies.length > 0) {
        return Promise.resolve();
      }
      return Promise.reject('Debes seleccionar al menos una póliza');
    };

    const checkGroups = async (params) => {
      if (formState.policies.length > 0) {
        const idx = params.field.split('.')[1];
        if (formState.policies[idx].groupCompanies.length > 0) {
          return Promise.resolve();
        }
      }
      return Promise.reject('Debes seleccionar al menos un grupo de póliza');
    };

    // Form rules
    const formRules = {
      validityDate: [
        {
          required: true,
          message: 'Seleccione una fecha',
          trigger: 'change',
          type: 'object'
        }
      ],
      firstName: [
        {
          required: true,
          message: 'Ingrese primer nombre',
          trigger: 'change'
        }
      ],
      firstSurname: [
        {
          required: true,
          message: 'Ingrese primer apellido',
          trigger: 'change'
        }
      ],
      rut: [
        {
          required: true,
          validator: checkRut,
          trigger: 'change'
        }
      ],
      email: [
        {
          required: true,
          validator: checkEmail,
          trigger: 'change'
        }
      ],
      company: [
        {
          required: true,
          message: 'Seleccione una empresa',
          trigger: 'change',
          type: 'string'
        }
      ],
      group: [
        {
          required: true,
          message: 'Seleccione un grupo',
          trigger: 'change',
          type: 'string'
        }
      ],
      insurance: [
        {
          required: true,
          message: 'Seleccione una aseguradora',
          trigger: 'change',
          type: 'string'
        }
      ],
      message: [
        {
          required: true,
          message: 'Escriba un mensaje',
          trigger: 'change',
          type: 'string'
        }
      ],
      currentPolicy: [
        {
          required: true,
          validator: checkPolicies,
          trigger: 'change'
        }
      ],
      documents: [
        {
          type: 'array',
          required: true,
          message: 'Seleccione un documento',
          trigger: 'change'
        }
      ],
      fileList: [
        {
          type: 'array',
          required: true,
          message: 'Agrege un documento',
          trigger: 'change'
        }
      ]
    };

    const updateMessage = () => {
      switch (formState.typeForm) {
        case '1':
          formState.message =
            'Para que puedas recibir los beneficios de tu empresa es necesario que completes los siguientes pasos:';
          break;
        case '2':
          formState.message =
            'A través del presente correo solicitamos la siguiente alta de titular:';
          break;
        default:
          formState.message =
            'Por favor selecciona un tipo de formulario válido.';
      }
    };

    updateMessage();

    watch(
      () => formState.typeForm,
      () => {
        updateMessage();
      }
    );

    // When 'Envío de información a' changes, clear whichever value doesn't apply anymore
    watch(
      () => formState.typeForm,
      (newVal) => {
        // If Colaborador is selected, clear the uploaded files.
        // Gender/birthday date clear themselves via the selectedFormFields
        // watcher once they're no longer included for the current mode
        if (newVal === '1') {
          formState.fileList = [];
        } else {
          // Otherwise clear the checkbox-selectable documents
          formState.documents = [];
        }
      }
    );

    const showPendingPolicyModal = ref(false);
    const pendingPolicyConflicts = ref([]);

    const getLastTicketState = (ticket) => {
      if (ticket?.states?.length) {
        return [...ticket.states]
          .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
          .at(-1);
      }
      return ticket?.state ?? null;
    };

    const isTicketPending = (ticket) => {
      if (ticket?.isRequesting === true || ticket?.state === 'requested') {
        return true;
      }
      const lastState = getLastTicketState(ticket);
      const stateId = lastState?.stateId ?? lastState?.id;
      if (stateId === undefined || stateId === null) {
        return false;
      }
      return stateId !== 3 && stateId !== 4;
    };

    const normalizePolicyValue = (value) => {
      if (value === null || value === undefined) return '';
      return String(value).trim().toLowerCase();
    };

    const extractTicketPolicies = (ticket) => {
      const policies = ticket?.policies ?? [];
      if (Array.isArray(policies)) {
        return policies
          .map((p) => p?.id ?? p?.policyId ?? p?.numberPolicy ?? p)
          .map(normalizePolicyValue)
          .filter(Boolean);
      }
      return [normalizePolicyValue(policies)].filter(Boolean);
    };

    const checkPendingPolicies = async () => {
      const normalizedRut = rutHelper.normalizeRut(formState.rut);
      if (!normalizedRut || formState.policies.length === 0) {
        pendingPolicyConflicts.value = [];
        return false;
      }

      const resp = await store.dispatch(
        FETCH_TABLE_TICKETS_TEST,
        `type=Alta&employeeRut=${normalizedRut}&page=1&items_per_page=50`
      );
      const rows = resp?.data?.rows || [];
      const pendingRows = rows.filter(isTicketPending);

      const selectedPolicies = formState.policies.map((p) => ({
        id: normalizePolicyValue(p.policyId),
        label: normalizePolicyValue(p.numberPolicy)
      }));

      const conflicts = [];
      pendingRows.forEach((row) => {
        const rowPolicies = extractTicketPolicies(row);
        selectedPolicies.forEach((policy) => {
          const matchesById = policy.id && rowPolicies.includes(policy.id);
          const matchesByLabel =
            policy.label && rowPolicies.includes(policy.label);
          if (matchesById || matchesByLabel) {
            conflicts.push({
              id: `${row.id}-${policy.id || policy.label}`,
              policy: policy.label || policy.id,
              ticketId: row.id
            });
          }
        });
      });

      if (conflicts.length > 0) {
        pendingPolicyConflicts.value = conflicts;
        showPendingPolicyModal.value = true;
        return true;
      }

      pendingPolicyConflicts.value = [];
      return false;
    };

    // Handle the "next" button click
    const onSubmitForm = async () => {
      try {
        const resp = await formRef.value.validate();
        const hasPendingPolicy = await checkPendingPolicies();
        if (hasPendingPolicy) return;
        openResumeModal(resp);
      } catch (error) {
        console.log('error', error);
        formRef.value.scrollToField(error.errorFields[0].name[0]);
      }
    };

    // Create the registration ticket for the company
    const createIncorporation = async () => {
      resumeModal.buttonLoading = true;

      try {
        const formData = new FormData();
        formData.append('companyId', formState.company);
        formData.append('brokerId', store.getters[GET_LOGGED_USER].id);
        formData.append('insuranceCompanyId', formState.insurance);
        formData.append('startDate', normalizePicker(formState.validityDate));
        formData.append('firstName', formState.firstName);
        if (formState.secondName != '' && formState.secondName != null) {
          formData.append('secondName', formState.secondName);
        }
        formData.append('firstSurname', formState.firstSurname);
        if (formState.secondSurname != '' && formState.secondSurname != null) {
          formData.append('secondSurname', formState.secondSurname);
        }
        formData.append('rut', rutHelper.normalizeRut(formState.rut));
        formData.append('email', formState.email);
        if (formState.gender != '' && formState.gender != null) {
          formData.append('gender', formState.gender);
        }
        if (formState.birthdayDate != '' && formState.birthdayDate != null) {
          formData.append(
            'birthdayDate',
            moment(formState.birthdayDate).format('YYYY-MM-DD')
          );
        }
        formState.documents.forEach((e, i) => {
          formData.append(`filesInsurance[${i}]`, e);
        });
        formState.policies.forEach((e, i) => {
          formData.append(
            `policies[${i}]`,
            JSON.stringify({
              policyId: e.policyId,
              groupCompanies: e.groupCompanies
            })
          );
        });
        formData.append('message', formState.message);
        if (formState.typeForm == 2) {
          formData.append('typeForm', '2');
          if (isIncomeRequired.value) {
            formData.append(
              'incomeAmount',
              parseIncomeAmount(formState.incomeAmount)
            );
          }
          formState.coverageIds.forEach((coverageId, i) => {
            formData.append(`coverageIds[${i}]`, coverageId);
          });
          formState.fileList.forEach((file) => {
            formData.append('files', file);
          });
          formState.optionalFiles.forEach((optFile) => {
            formData.append('optionalFiles', optFile);
          });
          formState.dependents.forEach((d, i) => {
            formData.append(
              `dependents[${i}]`,
              JSON.stringify({
                ...d,
                rut: rutHelper.normalizeRut(d.rut),
                dateOfBirth: moment(d.dateOfBirth).format('YYYY-MM-DD')
              })
            );
          });

          const resp = await store.dispatch(
            POST_INDIVIDUAL_INCORPORATION_TICKET_TO_COMPANY,
            formData
          );
          ticketId.value = resp.id;
          showSuccess.value = true;
        } else {
          formData.append('typeForm', '1');
          formState.optionalFiles.forEach((optFile) => {
            formData.append('optionalFile', optFile);
          });
          formState.fileList.forEach((file) => {
            formData.append('file', file);
          });
          const resp = await store.dispatch(
            POST_INDIVIDUAL_INCORPORATION_TICKET_TO_COLLABORATOR,
            formData
          );
          ticketId.value = resp.id;
          showSuccess.value = true;
        }
        formRef.value.resetFields();
      } catch (error) {
        console.error(error);
        showSuccess.value = false;
        const errorMsg = error.response?.data?.message;
        if (errorMsg) {
          notification('error', 'Error', error.response.data.message);
        } else {
          notification('error', 'Error', 'Error al crear ticket');
        }
      }

      resumeModal.buttonLoading = false;
      closeResumeModal();
    };

    // * File upload
    const fileList = ref([]);
    const uploading = ref(false);

    // Remove a file from the file list
    const handleRemove = (file) => {
      const index = formState.fileList.indexOf(file);
      const newFileList = formState.fileList.slice();
      newFileList.splice(index, 1);
      formState.fileList = newFileList;
    };

    // Remove a file from the optional files upload
    const handleRemoveOptional = (file) => {
      const index = formState.optionalFiles.indexOf(file);
      const newFileList = formState.optionalFiles.slice();
      newFileList.splice(index, 1);
      formState.optionalFiles = newFileList;
    };

    // Add an optional file to the input
    const beforeUploadOptional = (file) => {
      if (formState.optionalFiles.length < 5) {
        const fileSize = file.size / 1024 / 1024;
        if (fileSize > 5) {
          message.error('El archivo excede el peso máximo 5MB');
        } else {
          formState.optionalFiles = [...formState.optionalFiles, file];
        }
      } else {
        message.error('Máximo archivos a subir es 5');
      }
      return false;
    };

    // Method called before uploading the file, used to validate the file size
    const beforeUpload = (file) => {
      const maxFiles = formState.typeForm == 2 ? 10 : 5;
      const fileSize = file.size / 1024 / 1024;
      if (formState.fileList.length >= maxFiles) {
        message.error(`No puedes adjuntar más de ${maxFiles} archivos`);
      } else if (fileSize > 5) {
        message.error('El archivo excede el peso máximo 5MB');
      } else {
        formState.fileList = [...formState.fileList, file];
      }
      return false;
    };

    // Upload files to the backend
    const handleUpload = async (id) => {
      const formData = new FormData();
      fileList.value.forEach((file) => {
        formData.append('file', file);
      });
      formData.append('ticketId', id);
    };

    // * Main data fetching
    // Vuex
    const store = useStore();

    // Fetching insurance companies
    const getInsuranceCompanies = async (id_company) => {
      inputsLockState[1].disabled = true;
      inputsLockState[1].loading = true;
      try {
        await store.dispatch(FETCH_INSURANCE_COMPANIES, {
          id_company
        });
      } catch (error) {
        const msg =
          error.response?.data?.message ||
          'Ocurrió un error al cargar las aseguradoras.';
        notification('error', 'Error', msg);
      }
      inputsLockState[1].loading = false;
      inputStatesHeriarchy(1);
    };

    // Fetching documents by insurance company
    const getInsuraceDocuments = async (id_insurance) => {
      inputsLockState[1].disabled = true;
      inputsLockState[1].loading = true;
      try {
        await store.dispatch(FETCH_INSURANCE_COMPANIES_DOCUMENTS, id_insurance);
      } catch (error) {
        const msg =
          error.response?.data?.message ||
          'Ocurrió un error al cargar los archivos de aseguradoras.';
        notification('error', 'Error', msg);
      }
      inputsLockState[1].loading = false;
      // Documents load in parallel with the policies: only unlock up to the
      // policies select, so a slower documents response never locks the groups
      // the policies load already enabled.
      inputsLockState[0].disabled = false;
      inputsLockState[1].disabled = false;
      inputsLockState[2].disabled = inputsLockState[2].loading;
    };

    // Incremented on every RUT/company/insurance change: only the latest
    // request may fill the policies or finish the loading state.
    let policiesRequestId = 0;

    const getPolicies = async (rut, id_company, id_insurance) => {
      const requestId = policiesRequestId;
      const isCurrentRequest = () => requestId === policiesRequestId;
      inputsLockState[2].disabled = true;
      inputsLockState[2].loading = true;
      try {
        await store.dispatch(FETCH_INSURANCE_COMPANY_POLICY, {
          rut,
          id_company,
          id_insurance,
          isCurrentRequest
        });
      } catch (error) {
        if (!isCurrentRequest()) return;
        const msg =
          error.response?.data?.message ||
          'Ocurrió un error al cargar las pólizas.';
        notification('error', 'Error', msg);
      }
      if (!isCurrentRequest()) return;
      inputsLockState[2].loading = false;
      inputStatesHeriarchy(3);
    };

    // Fetch the person's data by RUT
    const collaboratorSelectsDisabled = ref(false);

    const getEmployeeDataByRut = (rut) => {
      /*
      This one has more logic: as soon as the person's data is fetched by RUT,
      it immediately fills in the selects that hold that data
      */
      collaboratorSelectsDisabled.value = true;
      store
        .dispatch(FETCH_EMPLOYEE_DATA_BY_RUT, rutHelper.normalizeRut(rut))
        .then(() => {
          const {
            id,
            firstName,
            secondName,
            firstSurname,
            secondSurname,
            fullname,
            email,
            gender,
            birthdayDate
          } = store.getters[GET_EMPLOYEE_DATA];
          employeeId.value = id;
          formState.firstName = firstName;
          formState.secondName = secondName;
          formState.firstSurname = firstSurname;
          formState.secondSurname = secondSurname;
          formState.fullName = fullname;
          formState.email = email;
          formState.gender = employeeGenderToCode[gender] || null;
          formState.birthdayDate = birthdayDate
            ? moment(birthdayDate, 'YYYY-MM-DD')
            : null;
        })
        .finally(() => {
          collaboratorSelectsDisabled.value = false;
        });
    };

    watch(
      () => formState.company,
      async (newCompany) => {
        formState.insurance = '';
        formState.currentPolicy = [];
        formState.policies = [];

        store.commit(SET_INSURANCE_COMPANY_POLICY, []);
        if (newCompany !== '') {
          await getInsuranceCompanies(newCompany);
        }
      }
    );

    const insuranceFormType = ref();

    watch(
      () => formState.insurance,
      async (newInsurance) => {
        formState.policies = [];
        formState.currentPolicy = [];
        store.commit(SET_INSURANCE_COMPANY_POLICY, []);

        if (newInsurance !== '') {
          await getInsuraceDocuments(newInsurance);
        }

        const found = insuranceCompanies.value.find(
          (i) => i.value === newInsurance
        );

        insuranceFormType.value = found ? found.formType : null;
      }
    );

    watch(
      () => [formState.rut, formState.company, formState.insurance],
      async ([newRut, newCompany, newInsurance]) => {
        policiesRequestId += 1;
        formState.currentPolicy = [];
        formState.policies = [];

        store.commit(SET_INSURANCE_COMPANY_POLICY, []);

        const rutOk = Rut.validateRut(newRut);
        if (rutOk && newCompany !== '' && newInsurance !== '') {
          await getPolicies(newRut, newCompany, newInsurance);
        } else {
          // A pending request for the previous selection no longer applies.
          inputsLockState[2].loading = false;
        }
      }
    );

    const debounce = (cb, delay = 1000) => {
      let timeout;

      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          cb(...args);
        }, delay);
      };
    };

    const updateDebouceRut = debounce((text) => {
      getEmployeeDataByRut(text);
    }, 500);

    const validRut = computed(() => rutHelper.validateRut(formState.rut));

    watch(
      () => formState.rut,
      (newRut) => {
        if (newRut != '') {
          updateDebouceRut(newRut);
        }
      }
    );

    // List of things to keep in mind before calling the coverages endpoint
    // [ ] An employee must be found in the system (employeeId.value)
    // [ ] The RUT must also be valid
    // [ ] The company id must exist
    // [ ] The insurance company id must exist
    /*
    So whenever any of these conditions become true or change, the coverages
    endpoint has to be called — and it has to be called twice, once for
    current coverages and once for non-current, saving the data separately,
    so the count of current ones can be shown on the button
    */

    const currentCoverages = ref([]);
    const notCurrentCoverages = ref([]);

    const getCoveragesRefactored = (data) => {
      if (data.length > 0) {
        let indexCounter = 0;
        return data.flatMap((policy, index) =>
          policy.coverages.map((coverage) => {
            const new_coverage = {
              id: `# ${index + 1}`,
              key: indexCounter,
              policy_number: policy.numberPolicy,
              coverage: coverage.name
            };
            indexCounter += 1;
            return new_coverage;
          })
        );
      }
      return data;
    };

    watch(
      () => [
        employeeId.value,
        formState.rut,
        formState.company,
        formState.insurance
      ],
      async ([newEmployeeId, newRut, newCompany, newInsurance]) => {
        if (
          newEmployeeId != '' &&
          newEmployeeId != undefined &&
          Rut.validateRut(newRut) &&
          newCompany != '' &&
          newInsurance != ''
        ) {
          loadingPolicyCoverages.value = true;
          const current = await getCurrentEmployeeCoverages({
            id: newEmployeeId,
            companyId: newCompany,
            insuranceCompanyId: newInsurance,
            policyStatus: 'Vigente',
            coverageStatus: 'ACTIVE'
          });
          currentCoverages.value = getCoveragesRefactored(current);

          const not_current = await getCurrentEmployeeCoverages({
            id: newEmployeeId,
            companyId: newCompany,
            insuranceCompanyId: newInsurance,
            policyStatus: 'No Vigente',
            coverageStatus: 'INACTIVE'
          });

          notCurrentCoverages.value = getCoveragesRefactored(not_current);
          loadingPolicyCoverages.value = false;
        } else {
          store.dispatch(ACTION_CURRENT_EMPLOYEE_COVERAGE, []);
          currentCoverages.value = [];
          notCurrentCoverages.value = [];
        }
      }
    );

    const loadingPolicyCoverages = ref(false);
    const getCurrentEmployeeCoverages = async (payload) => {
      try {
        const resp = await store.dispatch(
          FETCH_CURRENT_EMPLOYEE_COVERAGE,
          payload
        );
        return resp.data;
      } catch (error) {
        notification('error', 'Error', error.response.data.message);
        loadingPolicyCoverages.value = false;
      }
    };

    const policyColumns = [
      {
        title: 'Id póliza',
        dataIndex: 'id'
      },
      {
        title: 'N° póliza',
        dataIndex: 'policy_number'
      },
      {
        title: 'Cobertura',
        dataIndex: 'coverage'
      }
    ];

    // * Data for the inputs
    const companies = computed(() => {
      return store.getters[GET_COMPANIES].map((obj) => {
        return {
          label: obj.businessName,
          value: obj.id.toString()
        };
      });
    });

    const insuranceCompanies = computed(() => {
      return store.getters[GET_INSURANCE_COMPANIES].map((obj) => {
        return {
          label: obj.businessName,
          value: obj.id.toString(),
          formType: obj.insuranceCompanyForm
            ? obj.insuranceCompanyForm.type
            : 'PDF_FORM',
          formFields: obj.formFields || []
        };
      });
    });

    // Fields configurable per insurance company. The backend now returns a
    // single flat array per insurer (no more per-process split); Colaborador
    // mode never requires them, Compañía mode uses the array as-is.
    const selectedFormFields = computed(() => {
      const selected = insuranceCompanies.value.find(
        (i) => i.value === formState.insurance
      );
      if (!selected) return [];
      return formState.typeForm == '1' ? [] : selected.formFields;
    });

    // The dependents section of this form only exists in Compañía mode, so
    // it always uses the insurer's flat fields array
    const selectedCargasFormFields = computed(() => {
      const selected = insuranceCompanies.value.find(
        (i) => i.value === formState.insurance
      );
      return selected ? selected.formFields : [];
    });

    // Clears any field that's no longer in the resolved list (the insurance
    // company or the Colaborador/Compañía mode changed), no special-casing per mode
    watch(selectedFormFields, (newFields) => {
      if (!newFields.some((f) => f.field === 'gender')) {
        formState.gender = null;
      }
      if (!newFields.some((f) => f.field === 'birthdayDate')) {
        formState.birthdayDate = null;
      }
    });

    watch(selectedCargasFormFields, (newFields) => {
      if (!newFields.some((f) => f.field === 'gender')) {
        formState.dependents.forEach((d) => {
          d.gender = null;
        });
      }
    });

    const insuranceDocuments = computed(() => {
      return store.getters[GET_INSURANCE_COMPANIES_DOCUMENTS].map((x) => {
        return {
          label: x.name,
          value: x.id
        };
      });
    });

    const companyPolicies = computed(() => {
      return store.getters[GET_INSURANCE_COMPANY_POLICY].map((obj) => {
        return {
          label: `${obj.numberPolicy}`,
          value: obj.idPolicy.toString(),
          insuranceBrokerId: obj.insuranceBrokerId,
          groupOptions: obj.groupCompanies.map((g) => {
            return {
              label: g.name,
              value: g.id.toString()
            };
          }),
          coverageOptions: obj.coverageOptions || []
        };
      });
    });

    const insuranceBrokerWarning = computed(() =>
      getInsuranceBrokerWarning(
        (formState.currentPolicy || []).map((policyId) =>
          companyPolicies.value.find((policy) => policy.value == policyId)
        )
      )
    );

    const availableHolderCoverages = computed(() => {
      const seen = new Set();
      return formState.policies.flatMap((policy) => {
        const selectedGroups = new Set(
          policy.groupCompanies.map((groupCompanyId) => Number(groupCompanyId))
        );
        return (policy.coverageOptions || [])
          .filter((coverage) =>
            selectedGroups.has(Number(coverage.groupCompanyId))
          )
          .filter((coverage) => {
            const numericId = Number(coverage.id);
            if (seen.has(numericId)) return false;
            seen.add(numericId);
            return Number.isInteger(numericId) && numericId > 0;
          })
          .map((coverage) => ({
            value: Number(coverage.id),
            label: coverage.name,
            required: coverage.required === true
          }));
      });
    });

    const previousAvailableHolderCoverageIds = ref(new Set());
    const previousHolderFormType = ref(formState.typeForm);

    watch(
      [availableHolderCoverages, () => formState.typeForm],
      ([coverages, typeForm]) => {
        const availableCoverageIds = new Set(
          coverages.map((coverage) => coverage.value)
        );
        const newlyAvailableCoverageIds = [...availableCoverageIds].filter(
          (coverageId) =>
            !previousAvailableHolderCoverageIds.value.has(coverageId)
        );

        if (typeForm == 2) {
          const selectedCoverageIds = new Set(
            formState.coverageIds.map((coverageId) => Number(coverageId))
          );
          if (previousHolderFormType.value != 2) {
            newlyAvailableCoverageIds.push(...availableCoverageIds);
          }
          coverages
            .filter((coverage) => coverage.required)
            .forEach((coverage) => selectedCoverageIds.add(coverage.value));
          newlyAvailableCoverageIds.forEach((coverageId) =>
            selectedCoverageIds.add(coverageId)
          );
          formState.coverageIds = [...selectedCoverageIds].filter((id) =>
            availableCoverageIds.has(id)
          );
        } else {
          formState.coverageIds = formState.coverageIds.filter((id) =>
            availableCoverageIds.has(Number(id))
          );
        }

        previousAvailableHolderCoverageIds.value = availableCoverageIds;
        previousHolderFormType.value = typeForm;
      },
      { immediate: true }
    );

    // * Summary modal
    const resumeModal = reactive({
      visibility: false,
      buttonLoading: false,
      data: {
        date: '',
        insurer: '',
        company: '',
        group: '',
        policies: '',
        files: [],
        documents: [],
        rut: '',
        name: '',
        last: '',
        email: '',
        gender: '',
        birthdayDate: ''
      }
    });

    const openResumeModal = (data) => {
      // Fetch the data and transform it to send to the backend

      resumeModal.data.date = parseDate(data.validityDate).substring(0, 10);
      resumeModal.data.insurer = insuranceCompanies.value.find(
        (x) => x.value == data.insurance
      ).label;
      resumeModal.data.company = companies.value.find(
        (x) => x.value == data.company
      ).label;
      resumeModal.data.policies = formState.policies
        .map((p) => {
          const groups = p.groupOptions
            .filter((g) => p.groupCompanies.includes(g.value))
            .map((g) => g.label)
            .join(', ');
          return `${p.numberPolicy} (${groups})`;
        })
        .join(', ');

      if (formState.typeForm == 1) {
        if (data.documents !== undefined) {
          resumeModal.data.documents = insuranceDocuments.value
            .map((x) => {
              return data.documents.includes(x.value) ? x.label : '';
            })
            .filter((el) => el !== '');
        } else {
          resumeModal.data.documents = [];
        }
      } else {
        resumeModal.data.files =
          data.fileList == undefined || data.fileList == []
            ? ''
            : data.fileList.map((x) => {
                return x.name;
              });
        const dependents = {};
        Object.keys(data).forEach((key) => {
          if (key.includes('dependents')) {
            const index = key.split(',')[1];
            const attr = key.split(',')[2];
            if (!dependents[index]) {
              dependents[index] = {};
            }
            dependents[index][attr] = data[key];
          }
        });
        resumeModal.data.dependents = Object.values(dependents);
      }

      resumeModal.data.rut = rutHelper.formatRut(data.rut);
      resumeModal.data.name = data.firstName;
      resumeModal.data.last = data.firstSurname;
      resumeModal.data.fullName = data.fullname;
      resumeModal.data.email = data.email;
      resumeModal.data.gender = data.gender
        ? genderOptions.find((g) => g.value === data.gender)?.label
        : '';
      resumeModal.data.birthdayDate = data.birthdayDate
        ? parseDate(data.birthdayDate).substring(0, 10)
        : '';

      // Open the modal
      resumeModal.visibility = true;
    };

    const closeResumeModal = () => {
      resumeModal.visibility = false;
    };

    // * Coverages and policies modal
    const policyCoveragesModalRef = ref();
    const openPolicyCoverage = () => {
      policyCoveragesModalRef.value.openModal();
    };

    onMounted(async () => {
      await store.dispatch(FETCH_COMPANIES);
    });

    const showError = ref(false);

    const verTicket = () => {
      router.push({ name: 'AltasDetalle', params: { id: ticketId.value } });
    };
    const handleOk = () => {
      showSuccess.value = false;
      showError.value = false;
    };

    const relationOptions = [
      {
        label: 'Cónyuge',
        value: 'SPOUSE'
      },
      {
        label: 'Conviviente',
        value: 'COHABITANT'
      },
      {
        label: 'Hijo(a)',
        value: 'CHILD'
      },
      {
        label: 'Padre/Madre',
        value: 'PARENT'
      },
      {
        label: 'Nieto(a)',
        value: 'GRANDCHILD'
      },
      {
        label: 'Hermano(a)',
        value: 'SIBLING'
      }
    ];

    return {
      isFutureDate,
      isUnderPolicyHolderMinAge,
      isIncomeRequired,
      formatIncome,
      POLICY_HOLDER_UNDERAGE_WARNING,
      // Variables
      handleOk,
      showError,
      verTicket,
      formRef,
      showSuccess,
      formState,
      formRules,
      uploading,
      fileList,
      companies,
      inputsLockState,
      insuranceCompanies,
      companyPolicies,
      insuranceBrokerWarning,
      resumeModal,
      DATE_FORMAT,
      ticketId,
      insuranceDocuments,
      routes,
      collaboratorSelectsDisabled,
      policyStatus,
      policyColumns,
      loadingPolicyCoverages,
      policyCoveragesModalRef,
      employeeId,
      // Functions
      onSubmitForm,
      handleRemove,
      beforeUpload,
      handleUpload,
      parseDate,
      createIncorporation,
      closeResumeModal,
      // formatRuts,
      handleRemoveOptional,
      beforeUploadOptional,
      getCurrentEmployeeCoverages,
      openPolicyCoverage,
      validRut,
      showPendingPolicyModal,
      pendingPolicyConflicts,
      currentCoverages,
      notCurrentCoverages,
      insuranceFormType,
      handleDeleteDependent,
      handleAddDependent,
      rutValidator,
      rutHelper,
      relationOptions,
      genderOptions,
      availableHolderCoverages,
      selectedFormFields,
      selectedCargasFormFields,
      handleAddPolicy,
      handleDeletePolicy,
      checkGroups
    };
  }
};
</script>
